import React from 'react'
import { Router, Route } from "react-router-dom";
import history from './history'
import { unProtectedRoute, protectedRoute } from "./routePaths";
import PrivateRoute from "./privateRoute";

const Routes = () => {
  return (
    <Router history={history}>
      {unProtectedRoute.map((routePath) => (
        <Route
          key={routePath.path}
          exact path={routePath.path}
          component={routePath.component} />))
      }
      {protectedRoute.map((routePath) => (
        <PrivateRoute
          key={routePath.path}
          exact path={routePath.path}
          component={routePath.component} />))
      }
    </Router>
  );
}

export default Routes;